export default __webpack_public_path__ + "static/diagonal-282438b26d333d335221a15685750e2a.png";